import { TypeBlockQuoteWithoutUnresolvableLinksResponse } from 'contentful-types'

import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'

// Component
import BlockQuote, { BlockQuoteProps } from './BlockQuote'

const ContentfulBlockQuote = withContentful<TypeBlockQuoteWithoutUnresolvableLinksResponse['fields'], BlockQuoteProps>(
  BlockQuote,
  {
    textStyle: (props) =>
      props.fields.textStyle?.toLowerCase() as Lowercase<
        TypeBlockQuoteWithoutUnresolvableLinksResponse['fields']['textStyle']
      >,
  }
)

export default ContentfulBlockQuote
